import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import cogSVG from "../images/cog.svg"
import helpSVG from "../images/help.svg"
import pwcLogoSVG from "../images/pwc-logo.svg"
import {Boundary} from "./Boundary"
import {Card} from "./Card"
import {Flex} from "./Flex"
import {HeaderButton} from "./HeaderButton"
import {HeaderLinks} from "./HeaderLinks"
import {Link} from "./Link"

const Header = (props) => {
  const HeaderContent = (
    <ContentFlex hasBoundary={props.hasBoundary}>
      <Link block to={props.titleLink}>
        <TitleDiv>
          <strong>{props.title}</strong>
        </TitleDiv>
      </Link>
      <LinksDiv>
        <HeaderLinks links={props.links} />
      </LinksDiv>
      <HeaderButton alt="Settings" src={cogSVG} />
      <HeaderButton alt="Help" src={helpSVG} />
    </ContentFlex>
  )

  return (
    <OuterDiv hasSideBar={props.hasSideBar}>
      <Card>
        <Link to="">
          <LogoDiv>
            <img src={pwcLogoSVG} alt="pwc" />
          </LogoDiv>
        </Link>
        {props.hasBoundary ? (
          <Boundary>{HeaderContent}</Boundary>
        ) : (
          HeaderContent
        )}
      </Card>
    </OuterDiv>
  )
}

const ContentFlex = styled(Flex)`
  margin-left: ${(props) =>
    props.hasBoundary ? 0 : props.theme.headerHeight}px;
  padding-left: ${(props) => (props.hasBoundary ? 0 : 1.5)}em;
`

const LinksDiv = styled.div`
  flex-grow: 1;
  line-height: ${(props) => props.theme.headerHeight}px;
`

const LogoDiv = styled.div`
  height: ${(props) => props.theme.headerHeight}px;
  left: 0;
  position: absolute;
  top: 0;
  width: ${(props) => props.theme.headerHeight}px;
  img {
    height: 100%;
  }
`

const OuterDiv = styled.div`
  height: ${(props) => props.theme.headerHeight}px;
  left: ${(props) => (props.hasSideBar ? props.theme.sideBarWidth : 0)}px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
`

const TitleDiv = styled.div`
  color: black;
  line-height: ${(props) => props.theme.headerHeight}px;
  margin-right: 1em;
  padding-right: 1.5em;
  position: relative;
  &::after {
    content: "";
    display: block;
    height: 1.5em;
    border-right: 1px solid ${(props) => props.theme.borderColorMedium};
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`

Header.defaultProps = {
  titleLink: '',
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  titleLink: PropTypes.string,
}

export {Header}
